import { FormEvent, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api/client';
import { Alert } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { GeneratePasswordAction } from '../../components/ui/GeneratePasswordAction';

export function ResetPasswordPage() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError('');
    setLoading(true);

    const formData = new FormData(event.currentTarget);
    const submittedPassword = String(formData.get('new-password') ?? password);

    try {
      const result = await api.post<{ message: string }>(`/api/account/reset-password/${token}`, {
        password: submittedPassword,
      });
      setMessage(result.message);
      setPassword('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Nueva contraseña</h1>
        {message ? <Alert tone="success">{message}</Alert> : null}
        {error ? <Alert tone="danger">{error}</Alert> : null}
        {!message ? (
          <form method="post" action="/reset-password" autoComplete="on" onSubmit={handleSubmit}>
            <Input
              label="Contraseña nueva"
              id="new-password"
              name="new-password"
              type="password"
              autoComplete="new-password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              showPasswordToggle
              labelAction={
                <GeneratePasswordAction disabled={loading} onGenerate={setPassword} />
              }
            />
            <Button type="submit" loading={loading}>
              Guardar contraseña
            </Button>
          </form>
        ) : (
          <p className="auth-card__footer">
            <Link to="/login">Ir al login</Link>
          </p>
        )}
      </div>
    </div>
  );
}
